import { useState } from "react";
import { AddressesSection } from "./components/AddressesSection";
import { BankAccountSection } from "./components/BankAccountSection";
import { DocumentsSection } from "./components/DocumentsSection";
import { EmploymentSection } from "./components/EmploymentSection";
import { KycDetails } from "./components/KycDetails";
import { ProfileIdentityCard } from "./components/ProfileIdentityCard";
import { ProfileTabs } from "./components/ProfileTabs";
import { useGetProfileQuery } from "@/app/profile/api/profile.api";

export function ProfilePage() {
  const { data, refetch } = useGetProfileQuery();
  const profile = data ?? null;
  const [activeTab, setActiveTab] = useState("kyc");

  return (
    <div className="grid grid-cols-1 gap-6 p-4 sm:p-6 md:grid-cols-5">
      <div className="md:col-span-2">
        <ProfileIdentityCard profile={profile} documents={profile?.documents ?? null} refetch={refetch} />
      </div>

      <div className="rounded-md border border-border bg-surface-raised p-6 shadow-sm md:col-span-3">
        <ProfileTabs value={activeTab} onValueChange={setActiveTab} />

        <div className="mt-6">
          {activeTab === "kyc" && <KycDetails profile={profile} />}
          {activeTab === "addresses" && <AddressesSection addresses={profile?.addresses ?? null} />}
          {activeTab === "documents" && <DocumentsSection documents={profile?.documents ?? null} />}
          {activeTab === "bank-account" && (
            <BankAccountSection bankDetails={profile?.bankDetails ?? null} documents={profile?.documents ?? null} />
          )}
          {activeTab === "employment-details" && <EmploymentSection profile={profile} />}
        </div>
      </div>
    </div>
  );
}
